import { StaticImageData } from 'next/image'

import {
  Roadmap001Image,
  Roadmap002Image,
  Roadmap003Image,
  Roadmap004Image,
  Roadmap005Image,
  Roadmap006Image,
} from 'Assets/Images/Sections/HowItWorksSection'

type HowItWorksSectionRoadmapItem = {
  id: string
  caption: string
  image: StaticImageData
  imageAlt: string
  title: string
}

export const HOW_IT_WORKS_SECTION_ROADMAP_ITEMS: HowItWorksSectionRoadmapItem[] =
  [
    {
      id: 'HowItWorksSectionRoadmapItem-001',
      image: Roadmap001Image,
      imageAlt: '',
      title: 'Become a member',
      caption:
        'Join to become a part of our inclusive membership. Once a member, you’ll gain exclusive access to all Emajin Golf events Australia-wide, as well as all the benefits, connections and more!',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-002',
      image: Roadmap002Image,
      imageAlt: '',
      title: 'Select your events',
      caption:
        'Now, you can explore the extensive calendar of Emajin events at all the top golf clubs and venues. Browse your ideal topics, speakers and community groups while only paying for what you attend.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-003',
      image: Roadmap003Image,
      imageAlt: '',
      title: 'Connect with synergy',
      caption:
        'While you’ll have plenty of opportunities to network organically with all of our members, we also use our Custom Connection Program, where we hand-pick ideal connections based on your size, scale and industry requirements.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-004',
      image: Roadmap004Image,
      imageAlt: '',
      title: 'Get proactive',
      caption:
        'Download the Emajin Golf app to connect with members on and off the golf course. The app gives you access to our entire community, you can stay up-to-date with all social outings and get involved with a vibrant membership of business professionals.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-005',
      image: Roadmap005Image,
      imageAlt: '',
      title: 'Invite your connections',
      caption:
        'As an Emajin Golf member, you can invite three first time visitors to each monthly event, providing a valuable corporate entertainment opportunity to extend to your colleagues, clients and other networks.',
    },
    {
      id: 'HowItWorksSectionRoadmapItem-006',
      image: Roadmap006Image,
      imageAlt: '',
      title: 'Play golf. Do business.',
      caption:
        'Now you have everything you need to succeed. Do great business by connecting more authentically with top-calibre C-Suite executives and industry leaders while enjoying the best golf courses and spending relationship-building time with the best people.',
    },
  ]
